export const csConstants = {
  LIST_GUIDANCE_REQUEST: "CS_LIST_GUIDANCE_REQUEST",
  LIST_GUIDANCE_SUCCESS: "CS_LIST_GUIDANCE_SUCCESS",
  LIST_GUIDANCE_FAILURE: "CS_LIST_GUIDANCE_FAILURE",
  UPDATE_GUIDANCE_REQUEST: "CS_UPDATE_GUIDANCE_REQUEST",
  UPDATE_GUIDANCE_SUCCESS: "CS_UPDATE_GUIDANCE_SUCCESS",
  UPDATE_GUIDANCE_FAILURE: "CS_UPDATE_GUIDANCE_FAILURE",
  LIST_REPORTS_REQUEST: "CS_LIST_REPORTS_REQUEST",
  LIST_REPORTS_SUCCESS: "CS_LIST_REPORTS_SUCCESS",
  LIST_REPORTS_FAILURE: "CS_LIST_REPORTS_FAILURE",
  VALIDATE_REPORT_REQUEST: "CS_VALIDATE_REPORT_REQUEST",
  VALIDATE_REPORT_SUCCESS: "CS_VALIDATE_REPORT_SUCCESS",
  VALIDATE_REPORT_FAILURE: "CS_VALIDATE_REPORT_FAILURE",
  VALIDATION_STATUS_REQUEST: "CS_VALIDATION_STATUS_REQUEST",
  VALIDATION_STATUS_SUCCESS: "CS_VALIDATION_STATUS_SUCCESS",
  VALIDATION_STATUS_FAILURE: "CS_VALIDATION_STATUS_FAILURE",
  PROCESS_REPORT_REQUEST: "CS_PROCESS_REPORT_REQUEST",
  PROCESS_REPORT_SUCCESS: "CS_PROCESS_REPORT_SUCCESS",
  PROCESS_REPORT_FAILURE: "CS_PROCESS_REPORT_FAILURE",
  RETRIEVE_REPORT_REQUEST: "CS_RETRIEVE_REPORT_REQUEST",
  RETRIEVE_REPORT_SUCCESS: "CS_RETRIEVE_REPORT_SUCCESS",
  RETRIEVE_REPORT_FAILURE: "CS_RETRIEVE_REPORT_FAILURE",
  LIST_ASSESSMENT_REPORT_TEMPLATES_REQUEST: "CS_LIST_ASSESSMENT_REPORT_TEMPLATES_REQUEST",
  LIST_ASSESSMENT_REPORT_TEMPLATES_SUCCESS: "CS_LIST_ASSESSMENT_REPORT_TEMPLATES_SUCCESS",
  LIST_ASSESSMENT_REPORT_TEMPLATES_FAILURE: "CS_LIST_ASSESSMENT_REPORT_TEMPLATES_FAILURE",
  CREATE_ASSESSMENT_REPORT_PREVIEW_REQUEST: "CS_CREATE_ASSESSMENT_REPORT_PREVIEW_REQUEST",
  CREATE_ASSESSMENT_REPORT_PREVIEW_SUCCESS: "CS_CREATE_ASSESSMENT_REPORT_PREVIEW_SUCCESS",
  CREATE_ASSESSMENT_REPORT_PREVIEW_FAILURE: "CS_CREATE_ASSESSMENT_REPORT_PREVIEW_FAILURE",
};